export const ESTATE_CATEGORY_ID = 'E0001';
export const STRUCTURE_CATEGORY_ID = 'E0002';
export const BUILDING_MAP_CATEGORY_ID = 'E0003';
export const LAND_OWNERSHIP_CATEGORY_ID = 'E0004';
export const SITUATION_CATEGORY_ID = 'E0005';
export const TYPE_OF_LAND_CATEGORY_ID = 'E0006';
export const USE_OF_AREA_CATEGORY_ID = 'E0007';
export const DISTRICT_CATEGORY_ID = 'E0008';
export const RENTAL_MANAGEMENT_METHOD_CATEGORY_ID = 'E0009';
export const PREFECTURE_CATEGORY_ID = 'S0013';
export const FROM_SCREEN_ESTATE_SEARCH = 1;
export const CANCEL_ESTATE = 2;
export const NO_FROM_SCREEN_ESTATE_SEARCH = 2;
export const MAX_IMAGE_UPLOAD = 10;
export const ESTATE_PROPERTIES = [
  { name: 'land' },
  { name: 'detached_houses' },
  { name: 'apartment' },
  { name: 'house' },
  { name: 'commercial_building' },
  { name: 'rental_housing' },
  { name: 'warehouse' },
  { name: 'real_estate' },
  { name: 'parking' },
  { name: 'hotel' },
  { name: 'sectional_apartment' },
  { name: 'category_store' },
  { name: 'division_office' },
];
export const TRANSPORT_METHOD_OPTIONS = [
  { label: '徒歩', value: 1 },
  { label: '車', value: 2 },
  { label: 'バス', value: 3 },
];

export const TRAIN_LINE_1 = 1;
export const TRAIN_LINE_2 = 2;
export const TRAIN_LINE_3 = 3;
export const BIDDING_TYPE_OPTIONS = [
  { label: '一般入札', value: 1 },
  { label: '1回限定入札', value: 2 },
];
export const PURPOSE_OPTIONS = [
  { label: '投資', value: 1 },
  { label: '実需', value: 2 },
];
export const TRANSACTION_MODE_OPTIONS = [
  { label: '売主', value: 1 },
  { label: '代理', value: 2 },
  { label: '専属', value: 3 },
  { label: '専任', value: 4 },
  { label: '一般', value: 5 },
];
export const REMUNERATION_TYPE_OPTIONS = [
  { label: '分かれ', value: 1 },
  { label: '当方不払', value: 2 },
  { label: '当方片手数', value: 3 },
  { label: '代理折半', value: 4 },
  { label: '相談', value: 5 },
];
export const AREA_TYPE_OPTIONS = [
  { label: '公簿面積', value: 1 },
  { label: '壁芯面積', value: 2 },
];
export const MANAGEMENT_METHOD_OPTIONS = [
  { label: '一部委託管理', value: 1 },
  { label: '全部委託管理', value: 2 },
  { label: '自主管理', value: 3 },
  { label: '該当なし', value: 4 },
];
export const PARKING_OPTIONS = [
  { label: 'あり', value: 1 },
  { label: 'なし', value: 2 },
];
export const TRANSPORT_METHOD_FOOT = 1;
export const TRANSPORT_METHOD_CAR = 2;
export const TRANSPORT_METHOD_BUS = 3;
export const TRANSPORT_METHOD = {
  [TRANSPORT_METHOD_FOOT]: '徒歩',
  [TRANSPORT_METHOD_CAR]: '車',
  [TRANSPORT_METHOD_BUS]: 'バス',
};
export const TRANSACTION_MODE_SELLER = 1;
export const TRANSACTION_MODE_PROXY = 2;
export const TRANSACTION_MODE_EXCLUSIVE = 3;
export const TRANSACTION_MODE_FULLTIME = 4;
export const TRANSACTION_MODE_GENERAL = 5;
export const TRANSACTION_MODE = {
  [TRANSACTION_MODE_SELLER]: '売主',
  [TRANSACTION_MODE_PROXY]: '代理',
  [TRANSACTION_MODE_EXCLUSIVE]: '専属',
  [TRANSACTION_MODE_FULLTIME]: '専任',
  [TRANSACTION_MODE_GENERAL]: '一般',
};
export const REMUNERATION_TYPE_DIVIDED = 1;
export const REMUNERATION_TYPE_NOTPAY = 2;
export const REMUNERATION_TYPE_KATATE = 3;
export const REMUNERATION_TYPE_DAIRI = 4;
export const REMUNERATION_TYPE_SODAN = 5;
export const REMUNERATION_TYPE = {
  [REMUNERATION_TYPE_DIVIDED]: '分かれ',
  [REMUNERATION_TYPE_NOTPAY]: '当方不払',
  [REMUNERATION_TYPE_KATATE]: '当方片手数',
  [REMUNERATION_TYPE_DAIRI]: '代理折半',
  [REMUNERATION_TYPE_SODAN]: '相談',
};
export const MANAGEMENT_METHOD_PARTIAL = 1;
export const MANAGEMENT_METHOD_ALLOUTSOURCED = 2;
export const MANAGEMENT_METHOD_SELF = 3;
export const MANAGEMENT_METHOD_NOTAPPLICABLE = 4;
export const MANAGEMENT_METHOD = {
  [MANAGEMENT_METHOD_PARTIAL]: '一部委託管理',
  [MANAGEMENT_METHOD_ALLOUTSOURCED]: '全部委託管理',
  [MANAGEMENT_METHOD_SELF]: '自主管理',
  [MANAGEMENT_METHOD_NOTAPPLICABLE]: '該当なし',
};
export const ESTATE_TYPE_REQUIRED = ['区分マンション', '区分店舗', '区分事務所'];
export const DOCUMENT_TYPES = {
  TRANSCRIPT: 1,
  IMPORTANT_INVESTIGATION_REPORT: 2,
};
export const DETAIL_ESTATE_TYPE_REQUIRED_1 = ['土地', '駐車場'];
export const DETAIL_ESTATE_TYPE_REQUIRED_2 = ['土地', '戸建住宅', '倉庫', '工場', '駐車場'];
export const DETAIL_ESTATE_TYPE_REQUIRED_3 = ['土地', 'ホテル', '倉庫', '工場', '駐車場'];
export const DETAIL_ESTATE_TYPE_REQUIRED_4 = [
  '土地',
  'ホテル',
  '倉庫',
  '工場',
  '駐車場',
  '戸建住宅',
];
export const DETAIL_ESTATE_TYPE_REQUIRED_5 = ['区分マンション', '区分店舗', '区分事務所'];
export const DETAIL_ESTATE_TYPE_REQUIRED_6 = [
  '土地',
  '戸建住宅',
  '1棟マンション',
  '1棟アパート',
  '1棟商業ビル',
  '賃貸併用住宅',
  '倉庫',
  '工場',
  '駐車場',
  'ホテル',
];
export const ESTATE_CREATE_STEP_0 = 0;
export const ESTATE_CREATE_STEP_1 = 1;
export const ESTATE_CREATE_STEP_2 = 2;
export const ESTATE_CREATE_STEP_3 = 3;

export const ESTATE_TYPES = [
  '土地',
  '戸建住宅',
  '1棟マンション',
  '1棟アパート',
  '1棟商業ビル',
  '賃貸併用住宅',
  '倉庫',
  '工場',
  '駐車場',
  'ホテル',
  '区分マンション',
  '区分店舗',
  '区分事務所',
];

export const MIN_DIFFERENT_PRICE = 5;

export const DOT_KEY_CODES = [190, 110];
export const BIDDING_CANCEL_TEXT = '出品取り下げ';
export const BIDDING_STATUS_TEXT = ['出品中', '出品取り下げ', '終了'];
export const WON_BID_STATUS_TEXT = [
  '落札承諾待ち',
  '落札承諾待ち(繰り上げ可)',
  '落札承諾済み',
  '終了',
  '繰り上げ承諾待ち',
  '繰り上げ承諾待ち(繰り上げ可)',
  '繰り上げ承諾済み',
  '終了',
  '終了',
];
export const MANAGEMENT_METHOD_TEXT = ['一部委託管理', '全部委託管理', '自主管理', '該当なし'];
export const TRANSACTION_MODE_TEXT = ['売主', '代理', '専属', '専任', '一般'];
export const REMUNERATION_TYPE_TEXT = ['分かれ', '当方不払', '当方片手数', '代理折半', '相談'];
export const YES_NO_QUESTION = ['あり', 'なし'];

export const BIDDING_TYPES = {
  GENERAL_BIDDING: 1,
  ONE_TIME_LIMITED_BID: 2,
};

export const CHECK = 'CHECK';
export const CLEAR = 'CLEAR';

export const ESTATE_CATEGORIES = {
  PRICE_FROM: 'S0001',
  PRICE_TO: 'S0002',
  TIME_FROM_STATION: 'S0003',
  TIME_TO_STATION: 'S0004',
  CONSTRUCT_AREA_FROM: 'S0007',
  CONSTRUCT_AREA_TO: 'S0008',
  CONSTRUCT_DATE_FROM: 'S0009',
  CONSTRUCT_DATE_TO: 'S0010',
  TOTAL_FLAT_FROM: 'S0011',
  TOTAL_FLAT_TO: 'S0012',
  TYPE: 'E0001',
  STRUCTURE: 'E0002',
  BUILDING_MAP: 'E0003',
  LAND_OWNERSHIP: 'E0004',
  SITUATION: 'E0005',
};

export const QUICK_GROSS_OPTIONS = [
  {
    from: 1,
    to: 2,
    title: '3分以下',
    value: 1,
  },
  {
    from: 2,
    to: 3,
    title: '4分以上～5分以下',
    value: 2,
  },
  {
    from: 3,
    to: 4,
    title: '6分以上～7分以下',
    value: 3,
  },
  {
    from: 4,
    to: 5,
    title: '8分以上～10分以下',
    value: 4,
  },
];

export const PRICE_RECOMMEND_OPTIONS = [
  {
    value: 1,
    title: '3億以上',
    from: 18,
    to: 1,
  },
  {
    value: 2,
    title: '1億~3億',
    from: 16,
    to: 18,
  },
  {
    value: 3,
    title: '5000万~1億',
    from: 11,
    to: 16,
  },
  {
    value: 4,
    title: '3000~5000万',
    from: 9,
    to: 11,
  },
  {
    value: 5,
    title: '1000~3000万',
    from: 5,
    to: 9,
  },
  {
    value: 6,
    title: '500~1000万',
    from: 3,
    to: 5,
  },
  {
    value: 7,
    title: '300~500万',
    from: 2,
    to: 3,
  },
  {
    value: 8,
    title: '300万以下',
    from: 1,
    to: 2,
  },
];

export const BUILDING_AREA_TYPE_RECOMMEND_OPTIONS = [
  {
    value: 1,
    title: '学生向け',
    selected: false,
    biko: 'student',
  },
  {
    value: 2,
    title: '単身者向け',
    selected: false,
    biko: 'single',
  },
  {
    value: 3,
    title: 'ファミリー向け',
    selected: false,
    biko: 'family',
  },
];

/* eslint-disable global-require */
export const TYPE_RECOMMEND_OPTIONS = [
  {
    value: 1,
    title: '1棟',
    icon: require('@/assets/images/Group_17336.svg'),
    selected: false,
    biko: 'one',
  },
  {
    value: 2,
    title: '区分',
    icon: require('@/assets/images/Group_17347.svg'),
    selected: false,
    biko: 'class',
  },
  {
    value: 3,
    title: '事業用',
    icon: require('@/assets/images/Group_17355.svg'),
    selected: false,
    biko: 'business',
  },
];
/* eslint-enable global-require */

export const START_DATE_OPTIONS = [
  {
    value: 1,
    title: '指定なし',
    label: '指定なし',
  },
  {
    value: 2,
    title: '1時間以内',
    label: '1時間以内',
  },
  {
    value: 3,
    title: '1日以内',
    label: '1日以内',
  },
  {
    value: 4,
    title: '3日以内',
    label: '3日以内',
  },
  {
    value: 5,
    title: '7日以内',
    label: '7日以内',
  },
];

export const PARKING_SLOT_OPTIONS = [
  {
    value: 1,
    title: '指定無し',
  },
  {
    value: 2,
    title: '有り',
  },
  {
    value: 3,
    title: '無し',
  },
];

export const PER_PAGE_OPTIONS = [
  {
    value: 10,
    label: '10件',
  },
  {
    value: 20,
    label: '20件',
  },
  {
    value: 30,
    label: '30件',
  },
  {
    value: 50,
    label: '50件',
  },
  {
    value: 100,
    label: '100件',
  },
];

export const HOKKAIDO_CODE_ID = '1';

export const SORT_BY_OPTIONS = [
  {
    value: 1,
    label: '新着・更新順',
  },
  {
    value: 2,
    label: '価格が安い順',
  },
  {
    value: 3,
    label: '価格が高い順',
  },
  {
    value: 4,
    label: '土地面積が広い順',
  },
  {
    value: 5,
    label: '土地面積が狭い順',
  },
  {
    value: 6,
    label: '建物面積が広い順',
  },
  {
    value: 7,
    label: '建物面積が狭い順',
  },
];

export const ITEM_IN_SECTION = 5;

export const FORM_PROPERTIES = {
  start_date: 1,
  price_from: 0,
  price_to: 0,
  transport_time_from: 0,
  transport_time_to: 0,
  transport_method: false,
  purpose: null,
  transaction_mode: null,
  remuneration_type: null,
  area_type: 0,
  construct_area_from: 0,
  construct_area_to: 0,
  construct_date_from: 0,
  construct_date_to: 0,
  free_word: '',
  total_flat_from: 0,
  total_flat_to: 0,
  land_unit_price_from: 0,
  land_unit_price_to: 0,
  shortest_delivery_date_from: null,
  shortest_delivery_date_to: null,
  building_map: [],
  structure: [],
  type: [],
  land_ownership: 0,
  situation: 0,
};

export const IGNORE_DISPLAY = ['指定なし', '指定無し', '下限なし', '上限なし'];

export const SEARCH_ESTATE_BY_ADDRESS = 'search-by-address';
export const SEARCH_BY_ADDRESS_SCREEN = 1;
export const SEARCH_ESTATE_BY_TRAINLINE = 'search-by-train-line';
export const SEARCH_BY_TRAINLINE_SCREEN = 2;

export const SEARCH_DEFAULT_PAGE = 1;
export const SEARCH_DEFAULT_PER_PAGE = 50;
export const VALUE_0 = 0;

export const PERMISSION_MODULE6 = 'module6';

export const STATUS_BIDDING = [1, 2, 3];
export const WON_STATUS_BIDDING = [1, 2, 3, 4, 5, 6, 7, 8, 9];
export const BIDDING_TYPE = [1, 2, 3];
export const STATUS_COLORS = [
  { text: '出品中', color_class: 'badge-success' },
  { text: '出品取り下げ', color_class: 'badge-danger' },
  { text: '落札取り消し', color_class: 'badge-danger' },
  { text: 'システムから落札取り消し', color_class: 'badge-danger' },
  { text: '繰り上げ取り消し', color_class: 'badge-danger' },
  { text: 'システム取り消し', color_class: 'badge-danger' },
  { text: '終了', color_class: 'badge-grey' },
  { text: '承諾が必要', color_class: 'badge-warning' },
  { text: '承諾が必要(繰り上げの可能性あり)', color_class: 'badge-warning' },
  { text: '回答が必要', color_class: 'badge-warning' },
  { text: '回答が必要(繰り上げの可能性あり)', color_class: 'badge-warning' },
  { text: '落札承諾待ち', color_class: 'badge-warning' },
  { text: '落札承諾待ち(繰り上げ可)', color_class: 'badge-warning' },
  { text: '繰り上げ承諾待ち', color_class: 'badge-warning' },
  { text: '繰り上げ承諾待ち(繰り上げ可)', color_class: 'badge-warning' },
  { text: '承諾済み', color_class: 'badge-primary' },
  { text: '繰り上げ承諾済み', color_class: 'badge-primary' },
  { text: '繰り上げ辞退済み', color_class: 'badge-primary' },
  { text: '落札承諾済み', color_class: 'badge-primary' },
];

export const BIDDING_STATUS = [
  {
    status_code: 1,
    status_label: '出品中',
    color: 'badge-success'
  },
  {
    status_code: 2,
    status_label: '出品取り下げ',
    color: 'badge-danger'
  },
  {
    status_code: 3,
    status_label: '終了',
    color: 'badge-grey'
  }
];

export const SELLER_STATUS = [
  {
    status_code: 1,
    status_label: '落札承諾待ち',
    color: 'badge-warning'
  },
  {
    status_code: 2,
    status_label: '落札承諾待ち(繰り上げ可)',
    color: 'badge-warning'
  },
  {
    status_code: 3,
    status_label: '落札承諾済み',
    color: 'badge-primary'
  },
  {
    status_code: 4,
    status_label: '終了',
    // color: 'badge-danger'
    color: 'badge-grey'
  },
  {
    status_code: 5,
    status_label: '繰り上げ承諾待ち',
    color: 'badge-warning'
  },
  {
    status_code: 6,
    status_label: '繰り上げ承諾待ち(繰り上げ可)',
    color: 'badge-warning'
  },
  {
    status_code: 7,
    status_label: '繰り上げ承諾済み',
    color: 'badge-primary'
  },
  {
    status_code: 8,
    status_label: '終了',
    // color: 'badge-primary'
    color: 'badge-grey'
  },
  {
    status_code: 9,
    status_label: '終了',
    color: 'badge-grey'
    // color: 'badge-danger'
  },
  {
    status_code: 10,
    status_label: '終了',
    color: 'badge-grey'
    // color: 'badge-danger'
  },
];

export const WON_BIDDER_STATUS = [
  {
    status_code: 1,
    status_label: '承諾が必要',
    color: 'badge-warning'
  },
  {
    status_code: 2,
    status_label: '承諾が必要(繰り上げの可能性あり)',
    color: 'badge-warning'
  },
  {
    status_code: 3,
    status_label: '承諾済み',
    color: 'badge-primary'
  },
  {
    status_code: 4,
    status_label: '落札取り消し',
    color: 'badge-danger'
  },
  {
    status_code: 5,
    status_label: '落札取り消し',
    color: 'badge-warning'
  },
  {
    status_code: 6,
    status_label: '落札取り消し',
    color: 'badge-warning'
  },
  {
    status_code: 7,
    status_label: '落札取り消し',
    color: 'badge-primary'
  },
  {
    status_code: 8,
    status_label: '落札取り消し',
    color: 'badge-primary'
  },
  {
    status_code: 9,
    status_label: '落札取り消し',
    color: 'badge-danger'
  },
  {
    status_code: 10,
    status_label: '落札取り消し',
    color: 'badge-danger'
  },
];

export const FORWARDER_STATUS = [
  {
    status_code: 1,
    status_label: '終了',
    color: 'badge-warning'
  },
  {
    status_code: 2,
    status_label: '終了',
    color: 'badge-warning'
  },
  {
    status_code: 3,
    status_label: '終了',
    color: 'badge-primary'
  },
  {
    status_code: 4,
    status_label: '終了',
    color: 'badge-danger'
  },
  {
    status_code: 5,
    status_label: '回答が必要',
    color: 'badge-warning'
  },
  {
    status_code: 6,
    status_label: '回答が必要(繰り上げの可能性あり)',
    color: 'badge-warning'
  },
  {
    status_code: 7,
    status_label: '繰り上げ承諾済み',
    color: 'badge-primary'
  },
  {
    status_code: 8,
    status_label: '繰り上げ辞退済み',
    color: 'badge-primary'
  },
  {
    status_code: 9,
    status_label: '繰り上げ取り消し',
    color: 'badge-danger'
  },
  {
    status_code: 10,
    status_label: '繰り上げ取り消し',
    color: 'badge-danger'
  },
];
